<template>
  <div>
    <TopHeader />
    <div class="fl-sym-text-black fl-sym-p-5">
      <h3 class="fl-sym-text-5xl fl-sym-font-bold fl-sym-mt-12 fl-sym-mb-4">
        Hello.
      </h3>
      <p class="fl-sym-text-3xl fl-sym-font-light fl-sym-mb-1">
        First, let’s check if you have an emergency.
      </p>
    </div>

    <div class="fl-sym-p-5">
      <h3
        class="fl-sym-text-3xl fl-sym-leading-tight fl-sym-font-bold fl-sym-mb-3 fl-sym-mt-1 fl-sym-text-black"
      >
        {{ question.question }}
      </h3>
      <p
        class="fl-sym-text-intermediate fl-sym-mb-5 fl-sym-text-lg fl-sym-pr-3"
      >
        Is your pet showing any of the following signs? It’s okay if there is
        more than one, just choose the most concerning/troubling symptom.
      </p>
      <div class="fl-sym-grid">
        <button
          class="fl-sym-w-full fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 hover:fl-sym-border-primary"
          @click="submitAnswer(answer.answer)"
          v-for="(answer, index) in question.answers"
          :key="answer.answer"
          :class="{
            'fl-sym-button-primary':
              answer.answer === 'No, none of these emergency symptoms',
            'fl-sym-bg-primary':
              answer.answer === 'No, none of these emergency symptoms',
          }"
          :id="index"
        >
          {{ answer.answer }}
        </button>
      </div>
    </div>

    <div
      class="fl-sym-flex fl-sym-justify-center fl-sym-text-s fl-sym-font-semibold"
    >
      <div
        class="fl-sym-text-primary hover:fl-sym-text-opacity-75 fl-sym-mb-4"
        style="cursor: pointer"
        @click="$router.go(-1)"
      >
        Back
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from "@/components/headerNav/TopHeader.vue"
import { mapState } from "vuex"

export default {
  components: {
    TopHeader,
  },
  async mounted() {
    console.log("Begin.vue in pages mounted")
  },
  computed: {
    ...mapState({
      session_id: (state) => state.sc.session_id,
      question: (state) => state.sc.question,
    }),
  },
  methods: {
    async submitAnswer(val) {
      this.$store.dispatch("sc/next", { answer: val })
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style>
.fl-sym-grid {
  display: grid;
}
#\30 {
  order: 1;
}
#\31 {
  order: 2;
}
#\32 {
  order: 3;
}
#\33 {
  order: 4;
}
#\34 {
  order: 5;
}
#\35 {
  order: 6;
}
</style>
